/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["formData"] }] */
import { SelectDocument } from 'components';
import { FormHeader } from 'components/forms';
import { asForm } from 'components/forms/hoc';
import { InputField } from 'components/forms/inputs';
import { videoElementFormModel } from 'components/model/dataformModel';
import { useStores } from 'hooks';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { DocumentService } from 'services';
import { translate } from 'utils/translation';

const VideoElementForm = observer(({ formData, updateProperty }) => {
  const [document, setDocument] = useState(null);
  const { url, title = '', legend = '' } = formData;
  const { editionStore } = useStores();

  useEffect(() => {
    if (url) {
      const currentVideo = url.split('/');
      url && DocumentService.getDocumentDetails(currentVideo[currentVideo.length - 1])
        .then((response) => setDocument(response));
    }
  }, [url]);

  const handleDocumentDelete = useCallback(() => {
    runInAction('deleteVideoFromVideoElementForm', () => {
      formData.url = null;
      formData.videoUrl = null;
      formData.legend = '';
      formData.title = '';
      editionStore.setLastSaved(false);
    });
  }, [formData, editionStore]);

  const handleDocumentUpload = useCallback((fieldName, value, documentUploaded) => {
    if (documentUploaded) {
      runInAction('handleVideoUploadFromVideoElementForm', () => {
        formData.url = documentUploaded.hashId;
        formData.legend = documentUploaded.name;
        formData.title = documentUploaded.name;
        formData.videoUrl = documentUploaded.url;
      });

      updateProperty(fieldName, value);
    }
  }, [formData, updateProperty]);

  return (
    <>
      <FormHeader title="forms.element.video.title" />

      <SelectDocument
        contentType="VIDEO"
        defaultDocument={document}
        label={translate('forms.element.video.chooseVideo')}
        name="url"
        onDelete={handleDocumentDelete}
        onSelect={handleDocumentUpload}
      />

      <InputField
        label={translate('common.title')}
        name="legend"
        tooltip={translate('forms.element.video.legendInfo')}
        value={legend}
        onChange={updateProperty}
      />
      <InputField
        label={translate('common.altText')}
        name="title"
        tooltip={translate('forms.element.video.altTextInfo')}
        value={title}
        onChange={updateProperty}
      />
    </>
  );
});

export default asForm(VideoElementForm);

VideoElementForm.propTypes = {
  formData: videoElementFormModel.isRequired,
  updateProperty: PropTypes.func.isRequired
};